import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const addressService = {
  updateUserAddress,
  deleteUserAddress,
  getUserAddress,
  createUserAddress
}

function createUserAddress(objAddress) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objAddress)
  };
   
  return fetch(`${config.apiUrl}/address`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })

}

function updateUserAddress(objAddress) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objAddress)
  };

  return fetch(`${config.apiUrl}/address/${objAddress.id}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })

}

function deleteUserAddress(objAddress) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objAddress)
  }

  return fetch(`${config.apiUrl}/address/${objAddress.id}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
}

function getUserAddress(addressId) {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  }
  
  return fetch(`${config.apiUrl}/address/${addressId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })


}